import { TableCell, TableRow } from '@mui/material';
import { FC, useContext } from 'react';
import { MarketStore } from '../../../app/services/api/orderManagementClient';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UserContext } from '../../../components/shared/useUser';

type Props = {
  item: MarketStore;
  editBasePath?: string;
};

const StoreItemRow: FC<Props> = ({ item, editBasePath = '/stores/edit' }) => {
  const { t } = useTranslation('stores');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { hasPermissionTo } = useContext(UserContext);

  const canEdit = hasPermissionTo(['ConfigurationAdmin']) || hasPermissionTo(['StoreUpdate']);

  const handleRowClick = () => {
    if (!canEdit) return;
    const params = new URLSearchParams();
    const companyId = searchParams.get('companyId');
    const customerTypeId = searchParams.get('customerTypeId');
    const searchTerm = searchParams.get('searchTerm');

    if (companyId) params.set('companyId', companyId);
    if (customerTypeId) params.set('customerTypeId', customerTypeId);
    if (searchTerm) params.set('searchTerm', searchTerm);

    navigate(`${editBasePath}/${item.customerId}${params.toString() ? `?${params.toString()}` : ''}`);
  };

  return (
    <TableRow 
      onClick={canEdit ? handleRowClick : undefined}
      sx={{ 
        cursor: canEdit ? 'pointer' : 'default',
        '&:hover': canEdit ? {
          backgroundColor: 'action.hover',
        } : undefined,
      }}
    >
      <TableCell>
        {item.storeName}
      </TableCell>
      <TableCell>
        {item.marketName}
      </TableCell>
      <TableCell>
        {item.instanceName}
      </TableCell>
      <TableCell>
        {item.inventoryEnabled ? t('yes') : t('no')}
      </TableCell>
      <TableCell>
        {item.inventoryStartDate}
      </TableCell>
    </TableRow>
  );
};

export default StoreItemRow;
